<template>
    <div role="presentation" class="">
        <center-element role="presentation">
            <v-card role="complementary"  class="" style="border-radius: 10px !important;">
                <div role="region" class="content-inicio">
                    <div  role="presentation"  class="bemVindo bg-dark_white contrasteExtra perfil"  v-bind:class="{'border-radius-left': telaGrande, 'border-radius-top': !telaGrande}">
                        <!-- <div class="ma-5 " >
                                <h5 id="bemVindo" tabindex="-1" style="color: #292626" class="text-left acessibilidade">
                                <div role="group" class="text-right"> Cliente:</div>
                                <div role="group" class="text-right"> {{nome}}</div>
                            </h5>
                        </div> -->
                    </div>
                    <div  role="presentation" class="bemVindo contrasteExtra">
                        <div role="article" class="ma-3">
                            <h5 class="text-justify mx-4 my-5 acessibilidade" style="max-width: 500px">
                               <b> Olá, {{nome}}!</b><br>Aqui você terá a opção de gerar a 2° via do seu boleto bancário e também consultar e negociar seus contratos de forma simples e segura.
                            </h5>
                            <h6 class="text-justify mx-4 my-5 acessibilidade" style="max-width: 500px">Caso precise, no menu acima temos um link de "como funciona" que auxiliará nas suas dúvidas. </h6>
                            <div role="group" class="mx-2">
                                <v-btn v-show="acordos.length > 0" class="  px-2" style="font-size: 12px; background-color:purple; color:white "  @click="$router.push({name: 'rotas', params: {destino: '@acordos'}})"><v-icon size="20" class="pr-2">fas fa-money-check-alt</v-icon> Realizar pagamento</v-btn>
                                <v-btn v-show="dividas.length > 0" class=" px-4" style="font-size: 12px; background-color:#2A652D; color:white"  @click="$router.push({name: 'rotas', params: {destino: '@debitos'}})"><v-icon size="20" class="pr-2">fas fa-handshake</v-icon> Negociar</v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </center-element>
    </div>
</template>
<script>
import Vuex from '@/vuex/store'
import bus from '@/service/bus'
import CenterElement from './MyComponents/CenterElement.vue'
import {getNegociacoes, getDividas} from '@/service/service_autoatendimento/autoatendimento'
import { getParcelasPagSeguro } from '@/service/service_autoatendimento/autoatendimento'

export default {
    components: {CenterElement},
    data() {
        return {
            showNav: false,
            activeBtn: 1,
            acordos: [],
            dividas: [],
            nome: sessionStorage.getItem('user_name')
        }
    },

    mounted(){
        this.carregaAcordos()
        this.carregaDividas()
        window.fonte('inicio')
        Vuex.commit('SET_LOGIN', false)
        if(window.innerWidth >= 750)  Vuex.commit('SET_TELA', true)        
        window.onresize = ()=>{
            if(window.innerWidth >= 750) Vuex.commit('SET_TELA', true)  
            else Vuex.commit('SET_TELA', false)  
        }
        var main = document.querySelector('main')
        var d = main.getElementsByClassName('content-inicio')
        d[0].querySelector('h5').focus() // Para o leitor de voz ler o "Seja bem..." quando abrir a página
        // this.carregaAcordos()
        // this.carregaDividas()
    },
    computed: {
        telaGrande(){
            return Vuex.state.large
        }
    },
    methods: {
        carregaAcordos(){
            if(Vuex.state.acordos.length == 0) {
                getNegociacoes(sessionStorage.getItem('user_codigo')).then((retorno) => {
                    this.acordos = retorno.data.Retorno.map(item => {
                        item.show = false
                        return item
                    })
                    Vuex.commit('SET_ACORDOS', this.acordos)
                }).catch(() => {
                    // console.log(err)
                })
            } else this.acordos = Vuex.state.acordos
        },
        carregaDividas(){
            try {
                // let d = document.getElementById('txtCarregando')
                // d.focus()
                if(Vuex.state.dividas.length == 0) {
                    bus.$emit('load-in', { text: 'Um momento estamos carregados as informações dos contratos' })                    
                    var cpfcnpj = sessionStorage.getItem('user_codigo')
                    getDividas(cpfcnpj).then(response=>{
                        for(let i in response.data.Retorno.Dividas) {
                            if(response.data.Retorno.Dividas[i].NegociacaoPermitida) {
                                if (response.data.Retorno.Dividas[i].Credor.TpCredor == 46) {   

                                    getParcelasPagSeguro(response.data.Retorno.Dividas[i].ChaveDivida).then((div) => {
                                    let pos = div.data.Retorno
                                    let soma = pos.reduce((total, item) => {
                                        return total + item.SaldoLiquidacao;
                                    }, 0)
                                    response.data.Retorno.Dividas[i].ValorPrincipal = soma
                                    this.dividas.push(response.data.Retorno.Dividas[i])
                                    if(i == 0){
                                        bus.$emit('load-out')
                                        
                                    }
                                }).catch(() => {
                                    bus.$emit('load-out')
                                })


                                }else {
                                    this.dividas.push(response.data.Retorno.Dividas[i])
                                }
                            }
                        }
                        Vuex.commit('SET_DIVIDAS', this.dividas)
                    }).catch(() => {
                    })
                } else {
                    this.dividas = Vuex.state.dividas
                } 
    
            } catch (err) {
                // bus.$emit('load-out')
            }
        }
    }
}
</script>
<style>

</style>
